import { createRoutine } from "../../redux/utils/routine.utils";
export var getAgreement = createRoutine("AGREEMENT_GET");
export var createAgreement = createRoutine("AGREEMENT_CREATE");
export var mailAgreement = createRoutine("AGREEMENT_MAIL");
